import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DfsService } from '../../services/dfs.service';
import { LastEvent, NextEvent, UserEnergyEarnings } from '../../models/dfs-events.models';
import { DFS_CONSTANTS } from '../../constants/dfs.constants';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { LeaderBoardChartComponent } from './leaderboard-chart/leaderboard-chart.component';
import { WalletSummaryComponent } from "./wallet-summary/wallet-summary.component";
import { WeeklyForecastComponent } from "./weekly-forecast/weekly-forecast.component";
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { SavingsCalculatorDialogComponent } from '../../components/savings-calculator/savings-calculator.component';
import { MatIcon } from '@angular/material/icon';
import { EventConsentStatus } from '../../constants/dfs.enums';
import { UtilService } from '../../services/util.service';

interface Activity {
  date: string;
  type: string;
  amount: number;
  order: number;
  customer: string;
}

@Component({
  selector: 'app-dashboard',
  imports: [
    MatToolbarModule,
    MatCardModule,
    MatTableModule,
    MatButtonModule,
    MatDialogModule,
    MatChipsModule,
    CommonModule,
    LeaderBoardChartComponent,
    WeeklyForecastComponent,
    MatIcon
],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  eventStatus = EventConsentStatus;
  nextEvent!: NextEvent;
  lastEvent!: LastEvent;
  topPerformers: UserEnergyEarnings[] = [];
  dfsConstants = DFS_CONSTANTS;
  walletBalance = 0;
  tpi = false;

  displayedColumns: string[] = ['date', 'type', 'amount', 'order', 'customer'];

  // Example data source
  dataSource: Activity[] = [
    { date: 'May 30', type: 'Refund', amount: 20, order: 1005, customer: 'Alice Johnson' },
    { date: 'May 29', type: 'Order', amount: 40, order: 1004, customer: 'Bob Smith' },
    { date: 'May 28', type: 'Order', amount: 20, order: 1003, customer: 'Charlie Brown' },
    { date: 'May 27', type: 'Order', amount: 30, order: 1002, customer: 'Diana Davis' },
    { date: 'May 26', type: 'Order', amount: 10, order: 1001, customer: 'Eva Evans' }
  ];

  constructor(private dfsService: DfsService, private dialog: MatDialog, private util: UtilService) { }

  ngOnInit() {
    this.dfsService.isTpi.subscribe(isTpi => {
      this.tpi = isTpi;
    });
    this.fetchEvents();
    this.dfsService.getWalletSummary().subscribe((data) => {
      this.walletBalance = parseFloat(data.data.balance);
    });
  }

  fetchEvents(): void {
    this.dfsService.getEventSummary().subscribe((data) => {
      this.nextEvent = data.nextEvent;
      this.lastEvent = data.lastEvent;
      // this.nextEvent.date = new Date(this.nextEvent.date).toDateString();
      // this.nextEvent.time = new Date(this.nextEvent.time).toLocaleTimeString();
      // this.nextEvent.expectedUsage = 54.5;
      // this.nextEvent.earningsPerKW = 0.15;
      if (this.nextEvent.earningsPerKW && this.nextEvent.expectedUsage) {
        this.nextEvent.maxSavings = this.nextEvent.earningsPerKW * this.nextEvent.expectedUsage;
      } else {
        this.nextEvent.maxSavings = 0;
      }

    //  this.topPerformers = this.lastEvent.topPerformers;
      this.topPerformers = [];
    });
  }

  openSavingsCalculator(): void {
    this.dialog.open(SavingsCalculatorDialogComponent, {
      // width: '400px',
      data: { nextEvent: this.nextEvent }
    });
  }

  manageOpting (nextEvent: NextEvent, consent: boolean): void {
    this.dfsService.manageOptingForEvent(nextEvent, consent).subscribe({
      next: () => this.fetchEvents(),
      error: (error) => this.util.openSnackBar('An error occurred. Please try again later.', 'Close', 'error')
    });
  }

}
